import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { StructuredText } from 'react-datocms'
import ContentCustomer from './ContentCustomer';

function ColumnWrapper({ length, children })
{
  if (length === 1)
    return <>{children}</>
  else
    return (
      <div className="grid gap-8 grid-cols-1 sm:grid-cols-2">
        {children}
      </div>
    )
}

function Content({ content })
{
  console.log(content)
  return (
    <div className="max-w-4xl mx-auto py-16 px-8">
      <ColumnWrapper length={content.length}>
        {content.map((block) =>
          <div key={block.id} className="content-block">
            <StructuredText
              data={block.text}
              renderBlock={({ record }) =>
              {
                switch (record.__typename)
                {
                  case "DatoCmsBlockImage":
                    return <GatsbyImage image={getImage(record.image)} alt="TODO" />
                  case "DatoCmsBlockCustomer":
                    return <ContentCustomer {...record} />
                  default:
                    return null
                }
              }}
            />
          </div>
        )}
      </ColumnWrapper>
    </div>
  );
}

export default Content;